"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
exports.default = (function (_a) {
    var href = _a.href, onLoad = _a.onLoad;
    return (react_1.default.createElement("link", { rel: "stylesheet", type: "text/css", href: href, onLoad: onLoad }));
});
